import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import PrivateLabel from "../pages/private-label/page";
import CoffeeHospitality from "../pages/coffee-hospitality/page";
import OrganicDistributors from "../pages/organic-distributors/page";
import Ingredients from "../pages/ingredients/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/private-label",
    element: <PrivateLabel />,
  },
  {
    path: "/coffee-hospitality",
    element: <CoffeeHospitality />,
  },
  {
    path: "/organic-distributors",
    element: <OrganicDistributors />,
  },
  {
    path: "/ingredients",
    element: <Ingredients />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;